import React, { Fragment } from 'react';
import { Link } from 'react-router-dom';
import utils from '@utils';
import { Button } from 'react-bootstrap';
import { Image } from '@components/common';

export const officersColumns = (onClickReport) => [
	{
		property : 'officer',
		cell     : {
			formatters : [
				(value, {
					rowData : {
						FullName,
						OfficerRank,
						ProfilePhotoUrl,
					},
				}) => (
					<div className="flex mobile-max-width">
						<Image
							className="height-50 width-50 img-cover border-radius-rounded margin-right-10"
							src={ProfilePhotoUrl || ''}
							fallbackSrc="avatar"
						/>
						<div className="flex flex-justify-content-center flex-direction-column">
							<span className="font-regular display-block color-gray-mine-shaft">{ FullName }</span>
							<span className="font-regular display-block color-gray-bayoux">{ OfficerRank || 'Officer' }</span>
						</div>
					</div>
				),
			],
		},
	},
	{
		property : 'TotalJobCount',
		header   : {
			label    : 'Total Jobs',
			sortable : false,
		},
		cell : {
			formatters : [(value) => <p className="color-dark margin-top-15 text-center">{ value || 0 }</p>],
		},
	},
	{
		property : 'TotalHoursWorked',
		header   : {
			label    : 'Total Worked Hours',
			sortable : false,
		},
		cell : {
			formatters : [(value) => <p className="color-dark margin-top-15 text-center">{ parseFloat(value || 0).toFixed(2) }</p>],
		},
	},
	{
		property : 'Id',
		cell     : {
			formatters : [
				(value) => (
					<Button
						bsSize="small"
						onClick={onClickReport(value)}
					>
						View Report
						{' '}
						<i className="rkf rkf-share margin-left-10" />
					</Button>
				),
			],
		},
	},
];

export const jobColumns = (timeZoneId) => [
	{
		property : 'Date',
		cell     : {
			formatters : [
				(
					value,
					{
						rowData : {
							StartDateTime,
						},
					},
				) => (
					<Fragment>
						<small className="color-dark">Job Date</small>
						<small className="font-bold display-block">
							{ utils.parseUTCDateToTimeZone(StartDateTime, timeZoneId).format('ddd, MMM D, YYYY') }
						</small>
					</Fragment>
				),
			],
		},
	},
	{
		property : 'Title',
		cell     : {
			formatters : [
				(value) => (
					<small className="color-dark">{ value }</small>
				),
			],
		},
	},
	{
		property : 'officer',
		cell     : {
			formatters : [
				(
					value,
					{
						rowData : {
							AssignedOfficerId,
							AssignedOfficerPhotoUrl,
							AssignedOfficerRank,
							AssignedOfficerName,
						},
					},

				) => (
					<If condition={AssignedOfficerId}>
						<div className="flex mobile-max-width">
							<Image
								className="height-30 width-30 img-cover border-radius-rounded margin-right-10"
								src={AssignedOfficerPhotoUrl || ''}
								fallbackSrc="avatar"
							/>
							<p className="margin-bottom-0">
								<small className="display-block color-gray-mine-shaft">{ AssignedOfficerName }</small>
								<small className="display-block color-gray-bayoux">{ AssignedOfficerRank }</small>
							</p>
						</div>
					</If>
				),
			],
		},
	},
	{
		property : 'action',
		cell     : {
			formatters : [
				(value, { rowData : { Id } }) => (
					<Link
						to={`/jobs/${Id}`}
						className="btn btn-default"
					>
						View Details
						{' '}
						<i className="rkf rkf-share margin-left-10" />
					</Link>
				),
			],
		},
	},
];

export default {
	officersColumns,
	jobColumns,
};
